import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-traders-register-send',
  templateUrl: './traders-register-send.component.html',
  styleUrls: ['../style/global.css', './traders-register-send.component.css'],
})
export class TradersRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  initialized = false;
  constructor(private title: Title) {
    super();
  }

  ngOnInit(): void {
    this.title.setTitle(`認証用URL送信完了 | ${this.pageTitle}`);
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId]?.type);
  }

  get pageTitle() {
    return environment.apps[this.clientId]?.pageTitle || '';
  }

  get oemId() {
    return environment.apps[this.clientId]?.oemConfig?.id;
  }
}
